import * as React from 'react'
import ReadService from "../../../service/read";
import Wait from "../../wait";
import PopDetail from "../../popdetail";
import PlotDetailPane from "../plot/plot_detail_pane";
import {ProjectsService} from "../../../service/v1/projects";
import CreateService from "../../../service/create";

export default class CCRORejectedDataPane extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            show_actions: this.props.can_edit ? 'table-cell' : 'none',
            totalPages: 1,
            next: null,
            previous: null,
            pageSize: 50,
            newPageSize: 50,
            villages:[],
            village_id:0,
        }
        this.loadData = this.loadData.bind(this)
        this.loadLocalities = this.loadLocalities.bind(this)
        this.handleChanges = this.handleChanges.bind(this)
    }

    componentDidMount() {
        this.loadData()
        this.loadLocalities()
    }

    handleChanges=(e)=>{
        this.setState({
            [e.target.name]:e.target.value
        })
    }

    loadLocalities() {
        try{
            Wait.show('Loading Villages...')
            ReadService.fetchLocalitiesByProject(this.props.project.id).then(r=>{
                try {
                    let data = r.data.results

                    console.log(data)
                    this.setState({
                        villages:data,
                        village_id:data[0].id
                    })

                    setTimeout(()=>this.loadData(), 500)
                }catch (e) {
                    console.log(e)
                }


            })
        }catch (e) {
            console.log(e)
        }

    }

    render() {
        const fontFamily = 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif';
        
        const container = {
            width: '100%',
            height: '100vh',
            background: '#f6f8fa',
            fontFamily,
            display: 'flex',
            overflow: 'hidden'
        };
        
        const sidebar = {
            width: '280px',
            background: '#fff',
            borderRight: '1px solid #e0e7ef',
            height: '100vh',
            overflowY: 'auto',
            boxShadow: '2px 0 8px rgba(0,0,0,0.1)'
        };
        
        const sidebarHeader = {
            padding: '20px',
            borderBottom: '1px solid #e0e7ef',
            background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
            color: '#fff'
        };
        
        const sidebarTitle = {
            fontSize: '16px',
            fontWeight: '600',
            marginBottom: '4px'
        };
        
        const sidebarSubtitle = {
            fontSize: '12px',
            opacity: 0.8
        };
        
        const statsCard = {
            background: '#fff',
            borderRadius: 0,
            boxShadow: '0 4px 12px rgba(220,53,69,0.12), 0 2px 4px rgba(220,53,69,0.08)',
            padding: '20px',
            margin: '16px',
            border: '1px solid rgba(220,53,69,0.05)',
            textAlign: 'center'
        };
        
        const statsNumber = {
            fontSize: '32px',
            fontWeight: '700',
            color: '#dc3545',
            marginBottom: '8px'
        };
        
        const statsLabel = {
            fontSize: '14px',
            color: '#666',
            fontWeight: '500'
        };
        
        const mainContent = {
            flex: 1,
            padding: '0 24px 24px 24px',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        };
        
        const header = {
            padding: '18px 0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            fontSize: 18,
            fontWeight: 700,
            color: '#dc3545',
            fontFamily,
            borderBottom: '1px solid #e0e7ef',
            marginBottom: '24px',
            flexShrink: 0
        };
        
        const select = {
            padding: '10px 16px',
            border: '1px solid #e0e7ef',
            borderRadius: 0,
            fontSize: 14,
            fontFamily,
            background: '#fff',
            minWidth: '150px'
        };
        
        const btn = {
            background: 'linear-gradient(90deg, #dc3545 0%, #c82333 100%)',
            color: 'white',
            border: 'none',
            borderRadius: 0,
            padding: '6px 12px',
            fontWeight: 600,
            fontSize: 13,
            cursor: 'pointer',
            fontFamily,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            minWidth: 'auto'
        };
        
        const btnSecondary = {
            background: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: 0,
            padding: '6px 12px',
            fontWeight: 600,
            fontSize: 13,
            cursor: 'pointer',
            fontFamily,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            minWidth: 'auto'
        };
        
        const btnSuccess = {
            background: '#28a745',
            color: 'white',
            border: 'none',
            borderRadius: 0,
            padding: '6px 12px',
            fontWeight: 600,
            fontSize: 13,
            cursor: 'pointer',
            fontFamily,
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            minWidth: 'auto'
        };
        
        const dataCard = {
            background: '#fff',
            borderRadius: 0,
            boxShadow: '0 4px 12px rgba(220,53,69,0.12), 0 2px 4px rgba(220,53,69,0.08)',
            padding: '16px',
            fontFamily,
            marginBottom: '16px',
            border: '1px solid rgba(220,53,69,0.05)',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            minHeight: 0
        };
        
        const cardHeader = {
            fontSize: 16,
            fontWeight: 600,
            color: '#dc3545',
            marginBottom: '12px',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            paddingBottom: '8px',
            borderBottom: '2px solid #f0f0f0',
            flexShrink: 0
        };
        
        const tableContainer = {
            overflowX: 'auto',
            overflowY: 'auto',
            borderRadius: 0,
            border: '1px solid #e0e7ef',
            flex: 1,
            maxHeight: 'calc(100vh - 320px)',
            minHeight: 0
        };
        
        const table = {
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: 14,
            border: '1px solid #e0e7ef'
        };
        
        const tableHeader = {
            background: '#f8f9fa',
            padding: '8px 12px',
            textAlign: 'left',
            fontSize: 14,
            fontWeight: 600,
            color: '#dc3545',
            borderBottom: '2px solid #e0e7ef',
            borderRight: '1px solid #e0e7ef',
            borderLeft: '1px solid #e0e7ef'
        };
        
        const tableCell = {
            padding: '8px 12px',
            fontSize: 14,
            color: '#333',
            borderBottom: '1px solid #e0e7ef',
            borderRight: '1px solid #e0e7ef',
            borderLeft: '1px solid #e0e7ef'
        };
        
        const paginationContainer = {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '16px',
            padding: '20px',
            background: '#f8f9fa',
            borderTop: '1px solid #e0e7ef',
            flexShrink: 0
        };
        
        const paginationBtn = {
            padding: '8px 16px',
            border: '1px solid #e0e7ef',
            borderRadius: 0,
            background: '#fff',
            color: '#333',
            cursor: 'pointer',
            fontSize: 13,
            fontWeight: 500,
            transition: 'all 0.2s',
            minWidth: '100px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '6px'
        };
        
        const paginationInfo = {
            fontSize: 14,
            fontWeight: 600,
            color: '#dc3545',
            minWidth: '80px',
            textAlign: 'center'
        };

        return (
            <div style={container}>
                <div style={sidebar}>
                    <div style={sidebarHeader}>
                        <div style={sidebarTitle}>
                            <span className={'fa fa-times-circle'} style={{marginRight: 8}}/>
                        Rejected Data
                        </div>
                        <div style={sidebarSubtitle}>
                            {this.state.count || 0} records found
                        </div>
                    </div>

                    <div style={statsCard}>
                        <div style={statsNumber}>
                            {this.state.count || 0}
                        </div>
                        <div style={statsLabel}>
                            Total Rejected Records
                        </div>
                    </div>
                    
                    <div style={{padding: '16px', fontSize: '12px', color: '#666', textAlign: 'center'}}>
                        <span className={'fa fa-history'} style={{marginRight: 6}}/>
                        Updated 28 Minutes Ago
            </div>
                </div>

                <div style={mainContent}>
                    <div style={header}>
                        <span>
                            <span className={'fa fa-times-circle'} style={{marginRight: 12}}/>
                            Rejected Data Management
                        </span>
                        
                        <div style={{display: 'flex', gap: '12px', alignItems: 'center'}}>
                            <select 
                                name={'village'} 
                                style={select}
                                onChange={this.handleChanges}
                            >
                                <option value={undefined}>- Choose Village -</option>
                                {this.state.villages.map((d, i) => (
                                    <option value={d.id} key={i}>{d.name}</option>
                                ))}
                            </select>
                            
                            <button style={btnSecondary} onClick={() => this.loadData(0)}>
                    <span className={'fa fa-refresh'}/>Refresh
                </button>

                            <button style={btnSuccess} onClick={() => this.downloadExcel()}>
                    <span className={'fa fa-download'}/>Download Excel
                </button>

                            <button style={btn} onClick={() => this.loadData(0)}>
                                <span className={'fa fa-download'}/>Download .SHP
                            </button>
                        </div>
                    </div>
                    
                    <div style={dataCard}>
                        <div style={cardHeader}>
                            <span className={'fa fa-table'} style={{color: '#dc3545'}}/>
                            Rejected Records
                        </div>

                        <div style={tableContainer}>
                            <table style={table}>
                        <thead>
                        <tr>
                                        <th style={tableHeader}>#</th>
                                        <th style={tableHeader}>Claimed Data</th>
                                        <th style={tableHeader}>Claim Number</th>
                                        <th style={tableHeader}>Uka Number</th>
                                        <th style={tableHeader}>Registration Number</th>
                                        <th style={tableHeader}>Village</th>
                                        <th style={tableHeader}>Hamlet</th>
                                        <th style={tableHeader}>Created By</th>
                                        <th style={tableHeader}>Remarks</th>
                        </tr>
                        </thead>
                        <tbody>
                                    {this.state.data.map((d, i) => (
                                        <tr key={i} style={{cursor: 'pointer', verticalAlign: 'top'}}
                                        title={d.description}
                                        onClick={() => PopDetail.show(d.claim_no,
                                            <PlotDetailPane screen_code={this.props.screen_code}
                                                            taskId={this.props.taskId} parcel={d}
                                                            key={new Date().getMilliseconds()}/>)}>
                                            <td style={tableCell}>
                                    {this.state.next === null
                                        ? this.state.previous !== null
                                            ? this.state.previous.split('=').length > 1
                                                ? (this.state.previous.split('=')[1] * this.state.pageSize) + i + 1
                                                : this.state.pageSize + i + 1
                                            : 0 + i + 1
                                        : (this.state.next.split('=')[1] - 1) > 1
                                            ? (this.state.next.split('=')[1] - 2) * this.state.pageSize + i + 1
                                            : i + 1
                                    }
                                </td>
                                            <td style={tableCell}>{d.datetime}</td>
                                            <td style={tableCell}>
                                                <b style={{color: '#dc3545'}}>{d.claim_no}</b>
                                            </td>
                                            <td style={tableCell}>
                                                <b style={{color: '#dc3545'}}>{d.uka_namba}</b>
                                </td>
                                            <td style={tableCell}>
                                                <b style={{color: '#dc3545'}}>{d.registration_no}</b>
                                </td>
                                            <td style={tableCell}>
                                                <b style={{color: '#dc3545'}}>{d.locality_info.village}</b>
                                </td>
                                            <td style={tableCell}>
                                                <b style={{color: '#dc3545'}}>{d.locality_info.hamlet}</b>
                                </td>
                                            <td style={tableCell}>{d.created_user}</td>
                                            <td style={tableCell}>
                                                {d.last_remark.map((r, jj) => (
                                                    <div key={jj}
                                                         style={{color: r.action === 'reject' ? '#dc3545' : 'inherit'}}>
                                                        - {r.description}
                                                    </div>
                                                ))}
                                </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        
                        <div style={paginationContainer}>
                            <button 
                                onClick={() => {
                                    this.setState({
                                        newPageSize: this.state.newPageSize - this.state.pageSize
                                    })
                                    this.fetchProjectsByUrl(this.state.previous)
                                }} 
                                style={paginationBtn}
                                disabled={this.state.previous === null}
                            >
                                <span className={'fa fa-chevron-left'}/> Previous
                                </button>
                            
                            <span style={paginationInfo}>
                                {this.state.totalPages === 0 ? 0 : (this.state.newPageSize) / this.state.pageSize} / {this.state.totalPages}
                            </span>
                            
                            <button 
                                onClick={() => {
                                    this.setState({
                                        newPageSize: this.state.pageSize + this.state.newPageSize
                                    })
                                    this.fetchProjectsByUrl(this.state.next)
                                }} 
                                style={paginationBtn}
                                disabled={this.state.next === null}
                            >
                                Next <span className={'fa fa-chevron-right'}/>
                                </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    loadData(stage = 0) {
        try {
            Wait.show('Fetching Rejected Data....')
            ReadService.fetchCCRODataByStage(this.props.project.id, 'rejected').then(r => {
                Wait.dismiss()
                this.setState({
                    data: r.data.results,
                    totalPages: Math.ceil(r.data.count / this.state.pageSize),
                    next: r.data.next,
                    previous: r.data.previous,
                    count: r.data.count
                })
            })
        } catch (e) {

        }
    }

    fetchProjectsByUrl(url) {
        try {
            Wait.show('Fetching Projects...')
            ProjectsService.fetchProjectsByUrl(url).then(r => {
                Wait.dismiss()
                try {
                    this.setState({
                        data: r.data.results,
                        totalPages: Math.ceil(r.data.count / this.state.pageSize),
                        next: r.data.next,
                        previous: r.data.previous,
                        count: r.data.count
                    })
                } catch (e) {
                    console.log(e)
                }
            })
        } catch (e) {
            console.log(e)
        }
    }

    downloadExcel(){
        try {
            Wait.show('Generating Excel....')
            let village_id = this.state.village_id
            CreateService.downloadParcelExcel(village_id, 'rejected').then(response => {
                Wait.dismiss()
                const url = window.URL.createObjectURL(new Blob([response.data]));

                // Create a temporary link element
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'rejected.xlsx'); // Specify the filename

                // Simulate a click on the link to trigger the file download
                document.body.appendChild(link);
                link.click();

                // Clean up the temporary objects
                link.remove();
                window.URL.revokeObjectURL(url);

            })
        }catch (e) {
            console.log(e)
        }
    }
}
